export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://salonlev.ru').replace(/\/$/, '');

export const SITE_NAME = 'Л.Е.В. — Салон мужской эстетики';

export const DEFAULT_DESCRIPTION =
    'Салон мужской эстетики Л.Е.В. на Смоленском бульваре: стрижки любой сложности, борода, бритьё, уход в Москве. Запись онлайн. пн–вс 10:00–21:00.';

export const HOME_TITLE =
    'Л.Е.В. — Салон мужской эстетики | Стрижки любой сложности, борода, бритьё, уход в Москве';

export const BLOG_LIST_TITLE = `Блог | ${SITE_NAME}`;

export const BLOG_LIST_DESCRIPTION =
    'Статьи салона Л.Е.В. о мужских стрижках, уходе за бородой и бровями, стиле и процедурах в Москве на Смоленском бульваре.';

export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const HOME_KEYWORDS =
    'мужской салон, барбершоп Москва, мужская стрижка, стрижка бороды, мужской бровист, маникюр мужской, салон мужской эстетики, Смоленский бульвар, Л.Е.В.';

export const PAGE_META = {
    '/': {
        title: HOME_TITLE,
        description: DEFAULT_DESCRIPTION,
        keywords: HOME_KEYWORDS,
    },
    '/blog': {
        title: BLOG_LIST_TITLE,
        description: BLOG_LIST_DESCRIPTION,
    },
    '/offer': {
        title: `Публичная оферта | ${SITE_NAME}`,
        description:
            'Публичная оферта на оказание услуг салона мужской эстетики Л.Е.В. в Москве: условия записи, оплаты и оказания услуг.',
    },
    '/privacy': {
        title: `Политика конфиденциальности | ${SITE_NAME}`,
        description:
            'Политика конфиденциальности salonlev.ru: порядок обработки персональных данных пользователей сайта салона Л.Е.В.',
    },
    '/agreement': {
        title: `Пользовательское соглашение | ${SITE_NAME}`,
        description:
            'Пользовательское соглашение сайта салона мужской эстетики Л.Е.В.: правила использования сайта и сервисов.',
    },
    '/cookies': {
        title: `Соглашение об использовании cookies | ${SITE_NAME}`,
        description:
            'Соглашение об использовании файлов cookies на сайте salonlev.ru салона мужской эстетики Л.Е.В.',
    },
};

export const buildCanonical = (path) => {
    if (!path || path === '/') return `${SITE_URL}/`;
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${SITE_URL}${normalized}`;
};

export const buildArticleTitle = (title) => `${title} | ${SITE_NAME}`;

export const getPageMeta = (pathname) => {
    if (PAGE_META[pathname]) {
        return { ...PAGE_META[pathname], canonicalPath: pathname };
    }
    return { ...PAGE_META['/'], canonicalPath: '/' };
};
